@if (!universalService.isMobileDevice && universalService.activeRepo == 'main' && (universalService.currentTab == 'audio' || this.universalService.showFullViewAudioPlayer)) {
  <div class="audiosList">
    <ag-grid-angular class="ag-theme-material" id="audios-list-ag-grid" icons="icons" (gridReady)="onGridReady($event)" [gridOptions]="listService.audioPreviewOptions" (cellClicked)="listImpl.clickedOnCell($event)" (rowSelected)="onRowSelected($event)"
    (bodyScroll)="controller?.decideScrollCall($event)" [getRowClass]="getRowClass" [getRowStyle]="getRowStyle" (firstDataRendered)="recalculateHeightsWhenGridIsCompletelyRendered($event)" (rowDataUpdated)="rowDataUpdated($event)">
    </ag-grid-angular>
</div>
}
@if (universalService.selectedTab != 'Album Details') {
  <div>
    @if (universalService.isMobileDevice && universalService.showMobilePlayList) {
      <div class="mob-playlist-header">
        <span class="NeueFile_Cancel temporary_CloseIcon" (click)="closePlayList()"></span>
        <!-- <p>{{this.universalService.showLoader}}</p> -->
        <span class="playlist-headding">Playlist </span> <!--<span class="audio-count">({{this.universalService.priviewAudioFileCount}})</span>-->
      </div>
    }
    @if (universalService.isMobileDevice && universalService.showMobilePlayList) {
      <div class="scrollableContainer animated fadeIn mobilePlaylistCont" id="audioWrapperId" (scroll)="this.onMobileScrollDown($event)" > <!--[topOffset]="10"-->
        @for (audio of universalService.mobilePlayList; track audio; let i = $index) {
          <div class="m-all-files-list-view-main mb-2">
            <div class="row mt-2 listItem" (click)='playfromPlayList(i)' id="{{audio.objectKey}}" [ngClass]="{'highLightSelectedItem' : audio.selectedItem}">
              <div class="col-10 list_file_child">
                <div class="audio-icon-holder float-left ">
                  <i class="NeueAudio mr-2"></i>
                  <i class="NeuePlayFilled"></i>
                  <img src="{{audio.imageTranscodeUrl}}" class="audio-thumbnail mr-2" onerror="this.style.display = 'none'" />
                </div>
                <div class="m-details">
                  <h6><span>{{audio.objectName.split('.').slice(0, -1).join('.')}}</span>.{{audio.objectName.substring(audio.objectName.lastIndexOf('.') + 1)}}</h6>
                  <i class="audio-duration">{{audio.ObjectDuration}}</i>
                </div>
              </div>
              @if (audio.selectedItem) {
                <div class="col-2 text-right eqe-ani-cont">
                  <ng-lottie containerClass="moving-box" width="30px" height="30px" [options]="eqioptions" (animationCreated)="animationCreated($event)"></ng-lottie>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}
<div id="shareView" class='prvwCntnr'>
  <div id='audioplayer' class='mediaElement'>
    <div id="audioplayerCntnr" [ngClass]="universalService.currentTab != 'audio' ? 'notFromAudioTabScreen' : ''">
      @if (!clapprImpl?.previewNotAvailable) {
        <div class='audioCntnr' style="border: solid transparent;">
          <div class='audioPoster audioScreen d-none d-lg-block desktopAudioBox'>
            <div class='PlaybtnOvrLy hidden-xs'></div>
            <div class='defaultAudioPoster'>
              <div class="defaultAudioPosterIconCont">
                <span class="NeueAudio"></span>
              </div>
            </div>
            <div class='audioAlbumPoster' [ngStyle]="{'background-size':'100%','background-image': getBackgroundImageUrl() }"></div>
            <div class='audioScreen'>
              <!-- <div class="audioFileNameCont audioFileNameContDesk">
              <marquee>{{universalService.selectedAudioFile.objectName}}</marquee>
            </div> -->
            @if (universalService.currentTab == 'audio') {
              <div class="audioFileNameContDesk">
                <h3>{{universalService.selectedAudioFile.objectName}}</h3>
              </div>
            }
            @if (universalService.currentTab != 'audio') {
              <div class="audioFileNameContDesk">
                <h3>{{universalService.selectedAudioFile.objectName}}</h3>
              </div>
            }
            <span id="prev10" class='back10 '>
              <i class='Neueskip_Prev10' (click)="skipBack()"></i>
            </span>
            @if (universalService.audioPreview && universalService.selectedTab != 'Album Details') {
              <span id="repeatsong" class="repeat_btn">
                <i class='Neuerepeat' title="Repeat" (click)="repeatSongs()"></i>
              </span>
            }
            @if (universalService.audioPreview && universalService.selectedTab != 'Album Details') {
              <span id="previousaudio" class="previous_audio_btn">
                <i class='Neueprevious' title="Previous" (click)="fetchFile('fetchPrevious')"></i>
              </span>
            }
            <span id="screenId" class='icon-audioScreenPlay'>
              @if (!clapprImpl?.audioPlaying) {
                <i class="NeuePlayFilled" title="Play" (click)="playPauseAudio()"></i>
              }
              @if (clapprImpl?.audioPlaying) {
                <i class="NeuePause" title="Pause" (click)="playPauseAudio();universalService.isManualPause=true"></i>
              }
            </span>
            @if (universalService.audioPreview && universalService.selectedTab != 'Album Details') {
              <span id="nextaudio" class="next_audio_btn">
                <i class='Neuenext' title="Next" (click)="fetchFile('fetchNext')"></i>
              </span>
            }
            @if (universalService.audioPreview && universalService.selectedTab != 'Album Details') {
              <span id="shufflesong" class="shffle_btn">
                <i class='Neueshuffle' title="Shuffle" (click)="shufflePlay()"></i>
              </span>
            }
            <span id="next10" class='forward10'>
              <i class='Neueskip_Next-10' (click)="skipForward()"></i>
            </span>
          </div>
        </div>
        <div class='audioPoster audioPosterMobile d-lg-none'>
          <div style="position:relative">
            <div class='defaultAudioPoster'>
              <div class="defaultAudioPosterIconCont">
                <span class="NeueAudio"></span>
              </div>
            </div>
            <div class='audioAlbumPoster' [ngStyle]="{'background-size':'100%','background-image': getBackgroundImageUrl() }"></div>
            <div class='audioMobile'>
              <div ng-if="mediaType=='audio'" class="audioFileNameCont">
                <marquee>{{universalService.selectedAudioFile.objectName}}</marquee>
              </div>
              <!-- <div class="icon-mobilePlay">
              <i class='NeuePlayFilled' (click)='clapprImpl?.playPauseAudio()'></i>
              hjhj
            </div> -->
            @if (this.universalService.showAudioPreviewForFilter && universalService.selectedTab != 'Album Details') {
              <div class="mob-paylist-opt-cont">
                <span id="repeatsong" class="repeat_btn">
                  <i class='Neuerepeat' title="Repeat" (click)="repeatSongs()"></i>
                </span>
                <span id="mobPlayList" class="playlist_btn" [ngClass]="{'disablePlayListBtn':this.universalService.showMobilePlayList}">
                  <i class='NeueMusic' title="Playlist" (click)="openMobilePlayList($event);"></i>
                </span>
                <span id="shufflesong" class="shffle_btn">
                  <i class='Neueshuffle' title="Shuffle" (click)="shufflePlay()"></i>
                </span>
              </div>
            }
          </div>
        </div>
      </div>
      <div id="audio_player" class="shareAudio" [ngClass]="{'audioFilterPreviewDesk': this.universalService.showAudioWaves == false}" ></div>
      <div class='audioScreen mob-audio-opt-cont'>
        <span id="prev10" class='back10 '>
          <i class='Neueskip_Prev10' (click)="skipBack()"></i>
        </span>
        @if (this.universalService.showAudioPreviewForFilter) {
          <span id="previousaudio" class="previous_audio_btn">
            <i class='Neueprevious' title="Previous" (click)="fetchFile('fetchPrevious')"></i>
          </span>
        }
        <span id="screenId" class='icon-audioScreenPlay'>
          @if (!clapprImpl?.audioPlaying) {
            <i class="NeuePlayFilled" title="Play" (click)="playPauseAudio()"></i>
          }
          @if (clapprImpl?.audioPlaying) {
            <i class="NeuePause" title="Pause" (click)="playPauseAudio();universalService.isManualPause=true"></i>
          }
        </span>
        @if (this.universalService.showAudioPreviewForFilter) {
          <span id="nextaudio" class="next_audio_btn">
            <i class='Neuenext' title="Next" (click)="fetchFile('fetchNext')"></i>
          </span>
        }
        <span id="next10" class='forward10'>
          <i class='Neueskip_Next-10' (click)="skipForward()"></i>
        </span>
      </div>
    </div>
  }
@if (clapprImpl?.previewNotAvailable) {
  <div class="container no-preview-cont" >
    <div class="no-preview-wrapper">
      <div class="default-doc-holder" data-toggle="tooltip" >
        <span class="NeueAudio audio-tile"></span>
        <div class="docName">
          <h6>{{universalService.selectedAudioFile.objectShortName}}</h6>
          <span class="fileSize">{{universalService.selectedAudioFile.objectSize}}</span>
        </div>
      </div>
      <div class="noPreviewText">
        <p>No preview available for this file</p>
        @if (universalService.isMobileDevice) {
          <span id="mobPlayList" class="playlist_btn" style="font-size: 25px">
            <i class='NeueMusic' title="Playlist" (click)="openMobilePlayList($event);"></i>
          </span>
        }
        @if (!universalService.iOSdevice) {
          <div class="download_btn">
            <button class="Download ripple-fx" (click)="downloadItems()">Download</button>
          </div>
        }
      </div>
    </div>
  </div>
}

</div>
</div>
@if (universalService.selectedTab != 'Album Details') {
  <div>
    @if ( (!universalService.isMobileDevice && universalService.showAudioWaves) && universalService.currentTab == 'audio' ) {
      <ng-lottie class="audio_waves" containerClass="moving-box" [options]="options" (animationCreated)="animationCreated($event)"></ng-lottie>
    }
    @if (universalService.showAudioWaves && universalService.isMobileDevice) {
      <ng-lottie class="audio_waves" containerClass="moving-box" [options]="options" (animationCreated)="animationCreated($event)"></ng-lottie>
    }
  </div>
}
</div>